import {
  Divider,
  Heading, TabNavigation,
  TabNavigationItem,
} from '@livingdesign/react';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LINE_ITEM_TABS } from "../../../../constants/constants";
import InvoiceLineItemsStyles from "./InvoiceLineItems.styles";
import LineItemDatatable from './LineItemDataTable';
import {
  resetNonAdjustedPaginationForLineItems,
  resetAdjustedPaginationForLineItems,
  setLineItemCurrentTab
} from "../../../../store/actions/invoiceActions";
import ActionPopover from '../../../../components/Table/ActionPopover/ActionPopover';
import { useParams } from 'react-router-dom';
import LineItemBulkUpdate from '../../../../components/Modal/BulkUpdate/LineItemBulkUpdate';

const TabContent = ({ isCurrent, isAdjusted, invoiceStatus, fromMatter, setLoading, currentMatterTab, loading }) => {
  const renderFeeDatatable = () => {
    return <LineItemDatatable
      isCurrent={isCurrent}
      invoiceStatus={invoiceStatus}
      isAdjusted={isAdjusted}
      lineItemType={"Fees"}
      fromMatter={fromMatter}
      currentMatterTab={currentMatterTab}
      parentLoading={loading}
    />
  }
  switch (isCurrent) {
    case "Fees":
      return renderFeeDatatable()
    case "Expenses":
      return <LineItemDatatable
        isCurrent={isCurrent}
        invoiceStatus={invoiceStatus}
        isAdjusted={isAdjusted}
        lineItemType={"Expense"}
        fromMatter={fromMatter}
        currentMatterTab={currentMatterTab}
        parentLoading={loading}
      />
    default:
      return renderFeeDatatable()
  }
}

const NonAdjustedTabLayout = ({ loading, currentTab, fromMatter, currentMatterTab, invoiceStatus }) => {
  const classes = InvoiceLineItemsStyles();
  return (
    <div className={classes.lineItemTabNav}>
      <TabContent isAdjusted={false} isCurrent={currentTab} invoiceStatus={invoiceStatus} fromMatter={fromMatter} currentMatterTab={currentMatterTab} loading={loading} />
    </div>
  );
};

const NonAdjustedLineItems = ({ loading, currentTab, fromMatter, currentMatterTab, invoiceStatus }) => {
  const classes = InvoiceLineItemsStyles();
  return (
    <div data-testid="lineitems-datatable-wrap">
      <div className={classes.invoiceTitleWrap}>
        <Heading as="h1" size="medium" weight={700}>
          Line Items
        </Heading>
      </div>
      <NonAdjustedTabLayout loading={loading} currentTab={currentTab} fromMatter={fromMatter} currentMatterTab={currentMatterTab} invoiceStatus={invoiceStatus} />
    </div>
  )
}


const AdjustedTabLayout = ({ loading, currentTab, fromMatter, currentMatterTab, invoiceStatus }) => {
  const classes = InvoiceLineItemsStyles();
  return (
    <div className={classes.lineItemTabNav}>
      <TabContent isAdjusted={true} isCurrent={currentTab} invoiceStatus={invoiceStatus} fromMatter={fromMatter} currentMatterTab={currentMatterTab} loading={loading} />
    </div>
  );
};

const AdjustedLineItems = ({ loading, currentTab, fromMatter, currentMatterTab, invoiceStatus }) => {
  const classes = InvoiceLineItemsStyles();
  return (
    <div data-testid="lineitems-datatable-wrap">
      <div className={classes.invoiceTitleWrap}>
        <Heading as="h1" size="medium" weight={700}>
          Adjusted Line Items
        </Heading>
      </div>
      <AdjustedTabLayout loading={loading} currentTab={currentTab} fromMatter={fromMatter} currentMatterTab={currentMatterTab} invoiceStatus={invoiceStatus} />
    </div>
  )
}

const InvoiceLineItems = ({ loading, fromMatter, currentMatterTab, invoiceStatus, setLoading, fetchInvoiceDetail }) => {
  const classes = InvoiceLineItemsStyles();
  const lineItemCurrentTab = useSelector((state) => state?.invoice?.lineItemCurrentTab)
  const [tabs, setTabs] = useState(LINE_ITEM_TABS)
  const dispatch = useDispatch();
  const { invoiceId } = useParams();
  const invoiceDetail = useSelector((state) => state?.invoice?.invoiceDetail);
  const [openBulkUpdateModal, setOpenBulkUpdateModal] = useState(false)
  const adjustedSelectLineItems = useSelector((state) => state?.invoice?.adjustedSelectLineItems);
  const nonAdjustedSelectLineItems = useSelector((state) => state?.invoice?.nonAdjustedSelectLineItems);
  const [updateProperty, setUpdateProperty] = useState();

  useEffect(() => {
    if (invoiceDetail?.totalFeeBilled === undefined) {
      setTabs(["Expenses", "Fees"])
      dispatch(setLineItemCurrentTab("Expenses"))
    }
    else {
      dispatch(setLineItemCurrentTab("Fees"))
    }
  }, [])

  const bulkActionItems = [
    {
      "actionId": 1,
      "label": "Set net amount to zero",
      "isAboveDivider": true,
    },
    {
      "actionId": 2,
      "label": "Update rate",
      "isAboveDivider": true,
    },
    {
      "actionId": 3,
      "label": "Update units",
      "isAboveDivider": true,
    },
    {
      "actionId": 4,
      "label": "Restore to previous version",
      "isAboveDivider": true,
    },
    {
      "actionId": 5,
      "label": "Restore to original version",
      "isAboveDivider": true,
    }
  ]

  const handleChangeStatus = (id) => {
    switch (id) {
      case 1:
        setOpenBulkUpdateModal(true)
        setUpdateProperty("NET_AMOUNT_TO_ZERO");
        break;
      case 2:
        setOpenBulkUpdateModal(true)
        setUpdateProperty("UPDATE_RATE");
        break;
      case 3:
        setOpenBulkUpdateModal(true)
        setUpdateProperty("UPDATE_UNITS");
        break;
      case 4:
        setOpenBulkUpdateModal(true)
        setUpdateProperty("RESTORE_PREVIOUS");
        break;
      case 5:
        setOpenBulkUpdateModal(true)
        setUpdateProperty("RESTORE_ORIGINAL");
        break;
    }
  }

  const BulkActions = () => {
    return (
      <div style={{ marginRight: "20px" }}>
        <ActionPopover
          actionItems={bulkActionItems}
          onClickOption={handleChangeStatus}
          data-testid="bulk-actions"
          buttonText={"Bulk update"}
          disableStatus={![...adjustedSelectLineItems?.ids, ...nonAdjustedSelectLineItems?.ids].length}
        />
      </div>)
  }


  const lineItemsContent = () => {
    return (
      <div className={classes.invoiceLineItemsContainer}>
        <Divider />
        <AdjustedLineItems loading={loading} currentTab={lineItemCurrentTab} fromMatter={fromMatter} currentMatterTab={currentMatterTab} invoiceStatus={invoiceStatus} />
        <NonAdjustedLineItems loading={loading} currentTab={lineItemCurrentTab} fromMatter={fromMatter} currentMatterTab={currentMatterTab} invoiceStatus={invoiceStatus} />
      </div>
    )
  }

  return (
    <div className={classes.lineItemTabNav}>
      <div style={{ display: "flex", alignItems: "end" }}>
        <TabNavigation>
          {tabs?.map((item) => (
            <TabNavigationItem
              onClick={() => {
                dispatch(setLineItemCurrentTab(item));
                dispatch(resetNonAdjustedPaginationForLineItems());
                dispatch(resetAdjustedPaginationForLineItems())
              }}
              isCurrent={lineItemCurrentTab === item}
              key={item}
              data-testid={`invoice-${item.split(" ").join("-")}`}
              className={classes.lineItemTabNav}
            >
              {item}
            </TabNavigationItem>
          ))}
        </TabNavigation>
      </div>
      {lineItemsContent()}
      <LineItemBulkUpdate
        fetchInvoiceDetail={fetchInvoiceDetail}
        invoiceId={invoiceId}
        updateProperty={updateProperty}
        openBulkUpdateModal={openBulkUpdateModal}
        setOpenBulkUpdateModal={setOpenBulkUpdateModal}
        selectedLineItems={[...adjustedSelectLineItems?.ids, ...nonAdjustedSelectLineItems?.ids]}
        selectedLineItemsNumberMap={[...adjustedSelectLineItems?.idNumberMap, ...nonAdjustedSelectLineItems?.idNumberMap]}
        invoiceDetail={invoiceDetail}
      />
    </div>
  );
};

export default InvoiceLineItems;